/** Field-level undo/redo for the custom patient editor (whole patient snapshots). */

// ponytail: undo stack capped at 100 commits. Upgrade path is a longer or persisted history.
export const PATIENT_EDIT_HISTORY_LIMIT = 100;

export function clonePatientForHistory(patient) {
  return JSON.parse(JSON.stringify(patient ?? null));
}

export function patientEditHistoryKey(patient) {
  return JSON.stringify(patient ?? null);
}

export function patientsMatchForSave(left, right) {
  return patientEditHistoryKey(left) === patientEditHistoryKey(right);
}

export function commitPatientEditHistory(history, committedPatient, currentPatient, limit = PATIENT_EDIT_HISTORY_LIMIT) {
  const committed = clonePatientForHistory(committedPatient);
  const current = clonePatientForHistory(currentPatient);
  if (patientEditHistoryKey(committed) === patientEditHistoryKey(current)) {
    return { history, committed: null, changed: false };
  }
  const past = [...(history?.past || []), committed].slice(-limit);
  return {
    history: { past, future: [] },
    committed: current,
    changed: true,
  };
}

export function undoPatientEditHistory(history, committedPatient, limit = PATIENT_EDIT_HISTORY_LIMIT) {
  const past = history?.past || [];
  if (!past.length) return null;

  const previousPatient = past[past.length - 1];
  const committed = clonePatientForHistory(committedPatient);
  return {
    history: {
      past: past.slice(0, -1),
      future: [committed, ...(history?.future || [])].slice(0, limit),
    },
    patient: clonePatientForHistory(previousPatient),
  };
}

export function redoPatientEditHistory(history, committedPatient, limit = PATIENT_EDIT_HISTORY_LIMIT) {
  const future = history?.future || [];
  if (!future.length) return null;

  const nextPatient = future[0];
  const committed = clonePatientForHistory(committedPatient);
  return {
    history: {
      past: [...(history?.past || []), committed].slice(-limit),
      future: future.slice(1),
    },
    patient: clonePatientForHistory(nextPatient),
  };
}
